.ok {
  color: var(--blue);
  margin-right: 1em;
  margin-left: 0.5em;
}
